/**
 * Created by Claude on 21.08.2026
 */

class BaseComponent {
    constructor(options, context) {
        this.options = options || {};
        this.context = context || {};
        this.node = undefined; // added when component attached

        this.onBeforeCreate();
        this.onCreate();
    }

    onBeforeCreate() {

    }

    onCreate() {

    }

    onAttach() {

    }
}
